import type EnType from '../en-US/apiTest';

export default {
  'apiTestCase.messageError.praseError': '解析エラー',
  'apiTestCase.messageError.csvFormatError': 'CSV形式に一致しません',
  'apiTestCase.csvStandardRules': '《標準CSV規格》',
  'apiTestCase.report.statusCode': 'ステータスコード',
  'apiTestCase.report.statusLabel': 'HTTPステータスコード：',
  'apiTestCase.report.timeConsume': '所要時間',
  'apiTestCase.report.TabSizeMap': 'サイズ',
  'apiTest.label.actualRequest': '実際のRequest',
  'apiText.response.timings.event': 'イベント',
  'apiText.response.timings.event.prepare': '準備',
  'apiText.response.timings.event.socket': 'ソケットの初期化',
  'apiText.response.timings.event.dns': 'DNSクエリ',
  'apiText.response.timings.event.tcp': 'TCPハンドシェイク',
  'apiText.response.timings.event.ssl': 'SSLハンドシェイク',
  'apiText.response.timings.event.transfer': '待機中（TTFB）',
  'apiText.response.timings.event.download': 'コンテンツのダウンロード',
  'apiText.response.timings.event.process': '処理',
  'apiText.response.timings.event.total': '合計',
  'apiText.response.timings.timeLabel': '時間',
  'apiTest.debug.extension.install': 'インストールする',
  'apiTest.debug.extension.install.tips':
    'リクエストを送信するには、{appName} ブラウザ拡張機能をインストールする必要があります。Chrome と Edge ブラウザのみサポートされています。',
  'apiText.response.error.message.fallback': 'エラー：{message}',
  'apiText.response.error.help': 'Requestエラーのよくある質問',
  'apiTest.debug.usedTemplateVar': 'APIは環境変数{variables}を利用しています。',
  'apiTest.debug.setTemplateVar': '環境変数{variables}を設定してください。',
  'apiTest.debug.toSetVar': '移動',
  'apiTestCase.threadResources': 'スレッドリソース準備中',
} satisfies typeof EnType;
